import { render, staticRenderFns } from "./notifications.page.vue?vue&type=template&id=1c75a873&scoped=true&"
import script from "./notifications.page.vue?vue&type=script&lang=js&"
export * from "./notifications.page.vue?vue&type=script&lang=js&"
import style0 from "./notifications.page.vue?vue&type=style&index=0&id=1c75a873&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c75a873",
  null
  
)

export default component.exports